module.exports = __webpack_public_path__ + "4c578146ff5e017d6bdc68c744f375e1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-boot.png
// module id = 2865
// module chunks = 0